const homeLinkCardObj = [
   {
        class:"entrance-half",
        title:"Aviator",
        platform:"SPRIBE",
        type: "EGAME",
        gameCode: "SPRIBE-EGAME-001",
        imgSrc: "/assets/images/aviator.webp",
    },
    {
        class:"entrance-half",
        title:"Evolution",
        platform:"EVOLUTION",
        type: "",
        gameCode: "",
        imgSrc: "/assets/images/home/banner_evo-mrbook.png",
    },
    {
        class:"entrance-half",
        title:"Crazy Time",
        platform:"EVOLUTION",
        type: "LIVE",
        gameCode: "EVOLUTION-LIVE-006",
        imgSrc: "/assets/images/home/evo-crazy-time.webp",
    },
    {
        class:"entrance-half",
        title:"Crazy Time A",
        platform:"EVOLUTION",
        type: "LIVE",
        gameCode: "EVOLUTION-LIVE-114",
        imgSrc: "/assets/images/home/crazy-time-a.webp",
    },

    // {
    //     class:"entrance",
    //     title:"Stock Market",
    //     platform:"EVOLUTION",
    //     type: "LIVE",
    //     gameCode: "EVOLUTION-LIVE-291",
    //     imgSrc: "/assets/images/home/stock-market.webp",
    // },
    
    {
        class:"entrance-half",
        title:"Sexy",
        platform:"SEXYBCRT",
        type: "LIVE",
        gameCode: "MX-LIVE-001",
        imgSrc: "/assets/images/home/aesexy.webp",
    },
    {
        class:"entrance-half",
        title:"Live Casino",
        platform:"1",
        type: "",
        gameCode: "",
        imgSrc: "/assets/images/home/banner_casino-half.png",
    },
     {
        class:"entrance",
        title:"Saba Sports",
        platform:"SABA",
        type: "VIRTUAL",
        gameCode: "SABA-VIRTUAL-001",
        imgSrc: "/assets/images/home/saba-sportbook.jpeg",
    },
    {
        class:"entrance-half",
        title:"Ezugi Casino",
        platform:"",
        typeNew: "",
        gameCode: "",
        imgSrc: "/assets/images/home/banner_ezugi-mrbook.png",
    },
    {
        class:"entrance-half",
        title:"Evolution",
        platform:"EVOLUTION",
        type: "",
        gameCode: "",
        imgSrc: "/assets/images/home/evolution-casino.webp",
    },
    {
        class:"entrance-half",
        title:"Venus Casino",
        platform:"VENUS",
        type: "LIVE",
        gameCode: "VN-LIVE-001",
        imgSrc: "/assets/images/home/venus-casino.webp",
    },
    {
        class:"entrance-half",
        title:"Pragmatic Play",
        platform:"PP",
        type: "",
        gameCode: "",
        imgSrc: "/assets/images/home/pragmatic.webp",
    },
    {
        class:"entrance-half",
        title:"Super Spade",
        platform:"SPADE",
        type: "",
        gameCode: "",
        imgSrc: "/assets/images/home/superspade.webp",
    },
    {
        class:"entrance-half",
        title:"Jhandi Munda",
        platform:"KINGMAKER",
        type: "TABLE",
        gameCode: "KM-TABLE-030",
        imgSrc: "/assets/images/home/munda.webp",
    },
    {
        class:"entrance-half",
        title:"Rummy",
        platform:"JILI",
        type: "TABLE",
        gameCode: "JILI-TABLE-004",
        imgSrc: "/assets/images/home/rummygame.webp",
    },
    {
        class:"entrance-half",
        title:"Number Matka",
        platform:"KINGMAKER",
        type: "TABLE",
        gameCode: "KM-TABLE-021",
        imgSrc: "/assets/images/home/7d.webp",
    },
    {
        class:"entrance-half",
        title:"Horse Racing",
        platform:"KINGMAKER",
        type: "TABLE",
        gameCode: "KM-TABLE-048",
        imgSrc: "/assets/images/home/horseracing.webp",
    },
    {
        class:"entrance-half",
        title:"Rocket Cash",
        platform:"KINGMAKER",
        type: "TABLE",
        gameCode: "KM-TABLE-041",
        imgSrc: "/assets/images/home/rocketcash.webp",
    },
    {
        class:"entrance-half",
        title:"Hound Racing",
        platform:"KINGMAKER",
        type: "TABLE",
        gameCode: "KM-TABLE-055",
        imgSrc: "/assets/images/home/houndrace.webp",
    },
    {
        class:"entrance-half",
        title:"Sicbo",
        platform:"KINGMAKER",
        type: "TABLE",
        gameCode: "KM-TABLE-015",
        imgSrc: "/assets/images/home/banner-mt5-half.webp",
    },
    {
        class:"entrance-half",
        title:"Card Matka",
        platform:"KINGMAKER",
        type: "TABLE",
        gameCode: "KM-TABLE-022",
        imgSrc: "/assets/images/home/banner-sicbo-half.webp",
    },
    {
        class:"entrance-half",
        title:"7 Up 7 Down",
        platform:"KINGMAKER",
        type: "TABLE",
        gameCode: "KM-TABLE-028",
        imgSrc: "/assets/images/home/7upd.webp",
    },
    {
        class:"entrance-half",
        title:"Ludo",
        platform:"KINGMAKER",
        type: "TABLE",
        gameCode: "KM-TABLE-060",
        imgSrc: "/assets/images/home/bb.webp",
    },
    {
        class:"entrance-half",
        title:"32 Cards",
        platform:"KINGMAKER",
        type: "TABLE",
        gameCode: "KM-TABLE-039",
        imgSrc: "/assets/images/home/banner-numbermatka-half.webp",
    },
    {
        class:"entrance-half",
        title:"Andar Bahar",
        platform:"KINGMAKER",
        type: "TABLE",
        gameCode: "KM-TABLE-032",
        imgSrc: "/assets/images/home/banner-binary-half.webp",
    },
    {
        class:"entrance-half",
        title:"Teen Patti",
        platform:"KINGMAKER",
        type: "TABLE",
        gameCode: "KM-TABLE-046",
        imgSrc: "/assets/images/home/tp.webp",
    },
    {
        class:"entrance-half",
        title:"Cointoss",
        platform:"KINGMAKER",
        type: "TABLE",
        gameCode: "KM-TABLE-036",
        imgSrc: "/assets/images/home/cointoss.webp",
    },
    {
        class:"entrance-half",
        title:"Bonus Dice",
        platform:"KINGMAKER",
        type: "TABLE",
        gameCode: "KM-TABLE-043",
        imgSrc: "/assets/images/home/dice.webp",
    },
    {
        class:"entrance-half",
        title:"Cards Hilo",
        platform:"KINGMAKER",
        type: "TABLE",
        gameCode: "KM-TABLE-037",
        imgSrc: "/assets/images/home/hl.webp",
    },
    {
        class:"entrance-half",
        title:"Minesweeper",
        platform:"KINGMAKER",
        type: "TABLE",
        gameCode: "KM-TABLE-042",
        imgSrc: "/assets/images/home/mine.webp",
    },
    {
        class:"entrance-half",
        title:"Tai Xiu",
        platform:"KINGMAKER",
        type: "TABLE",
        gameCode: "KM-TABLE-017",
        imgSrc: "/assets/images/home/taixiu.webp",
    },
    {
        class:"entrance-half",
        title:"Thai",
        platform:"KINGMAKER",
        type: "TABLE",
        gameCode: "KM-TABLE-009",
        imgSrc: "/assets/images/home/thai.webp",
    },
    {
        class:"entrance-half",
        title:"Bai Cao",
        platform:"KINGMAKER",
        type: "TABLE",
        gameCode: "KM-TABLE-020",
        imgSrc: "/assets/images/home/baicao.webp",
    },
    {
        class:"entrance-half",
        title:"Bola Golek",
        platform:"KINGMAKER",
        type: "TABLE",
        gameCode: "KM-TABLE-035",
        imgSrc: "/assets/images/home/bola.webp",
    },
    {
        class:"entrance-half",
        title:"Jili City",
        platform:"JILI",
        type: "SLOT",
        gameCode: "JILI-SLOT-060",
        imgSrc: "/assets/images/home/jili.webp",
    },
    {
        class:"entrance-half",
        title:"Reign of Dragons",
        platform:"PP",
        type: "LIVE",
        gameCode: "PP-SLOT-007",
        imgSrc: "/assets/images/home/reignofdragons.webp",
    },
    {
        class:"entrance-half",
        title:"Mega Baccarat ",
        platform:"PP",
        type: "LIVE",
        gameCode: "PP-LIVE-061",
        imgSrc: "/assets/images/home/pp-mega-baccarat.webp",
    },
    {
        class:"entrance-half",
        title:"Mega Sic Bo",
        platform:"PP",
        type: "LIVE",
        gameCode: "PP-LIVE-025",
        imgSrc: "/assets/images/home/pmegasicbo.webp",
    },
    {
        class:"entrance-half",
        title:"Andar Bahar",
        platform:"PP",
        type: "LIVE",
        gameCode: "PP-LIVE-043",
        imgSrc: "/assets/images/home/pp-andar-bahar.webp",
    },
    {
        class:"entrance-half",
        title:"Dragon Tiger",
        platform:"PP",
        type: "LIVE",
        gameCode: "PP-LIVE-042",
        imgSrc: "/assets/images/home/pdt.webp",
    },
    {
        class:"entrance-half",
        title:"Football Blitz Top Card",
        platform:"PP",
        type: "LIVE",
        gameCode: "PP-LIVE-123",
        imgSrc: "/assets/images/home/pp-football-blitz-top-card.webp",
    },
    {
        class:"entrance-half",
        title:"Sweet Bonanza Candyland",
        platform:"PP",
        type: "LIVE",
        gameCode: "PP-LIVE-044",
        imgSrc: "/assets/images/home/pp-Sweet-Bonanza-Candyland.webp",
    },
    {
        class:"entrance-half",
        title:"Mega Wheel",
        platform:"PP",
        type: "LIVE",
        gameCode: "PP-LIVE-038",
        imgSrc: "/assets/images/home/pmegawheel.webp",
    },
    {
        class:"entrance-half",
        title:"Mega Roulette",
        platform:"PP",
        type: "LIVE",
        gameCode: "PP-LIVE-039",
        imgSrc: "/assets/images/home/pmegaroll.webp",
    },
    {
        class:"entrance-half",
        title:"Adventures Beyond Wonderland",
        platform:"PT",
        type: "LIVE",
        gameCode: "PT-LIVE-011",
        imgSrc: "/assets/images/home/pt-wonderland.webp",
    },
    {
        class:"entrance-half",
        title:"Cash Collect Roulette Live",
        platform:"PT",
        type: "LIVE",
        gameCode: "PT-LIVE-131",
        imgSrc: "/assets/images/home/pt-cash-collect.webp",
    },
    {
        class:"entrance-half",
        title:"Mega Fire Blaze Lucky Ball Live",
        platform:"PT",
        type: "LIVE",
        gameCode: "PT-LIVE-110",
        imgSrc: "/assets/images/home/pt-mega-fire-blaze-lucky-ball.webp",
    },
    {
        class:"entrance-half",
        title:"Mega Fire Blaze Roulette Live",
        platform:"PT",
        type: "LIVE",
        gameCode: "PT-LIVE-028",
        imgSrc: "/assets/images/home/pt-mega-fire-roulette.webp",
    },
    {
        class:"entrance-half",
        title:"The Greatest Cards Show",
        platform:"PT",
        type: "LIVE",
        gameCode: "PT-LIVE-086",
        imgSrc: "/assets/images/home/pt-card-show.webp",
    },
    {
        class:"entrance-half",
        title:"Mega Fire Blaze Lucky Ball Brasileiro",
        platform:"PT",
        type: "LIVE",
        gameCode: "PT-LIVE-108",
        imgSrc: "/assets/images/home/pt-brasileiro-roulette.webp",
    },
    {
        class:"entrance-half",
        title:"Spin a Win",
        platform:"PT",
        type: "LIVE",
        gameCode: "PT-LIVE-015",
        imgSrc: "/assets/images/home/pt-spin-a-win.webp",
    },
    {
        class:"entrance-half",
        title:"SicBo Deluxe",
        platform:"PT",
        type: "LIVE",
        gameCode: "PT-LIVE-003",
        imgSrc: "/assets/images/home/pt-sicbo-deluxe.webp",
    },
    {
        class:"entrance-half",
        title:"Greek Quantum Roulette",
        platform:"PT",
        type: "LIVE",
        gameCode: "PT-LIVE-076",
        imgSrc: "/assets/images/home/pt-greek-quantum-roulette.webp",
    },
    {
        class:"entrance-half",
        title:"Hi-Lo",
        platform:"PT",
        type: "LIVE",
        gameCode: "PT-LIVE-014",
        imgSrc: "/assets/images/home/pt-hilo.webp",
    },
    {
        class:"entrance-half",
        title:"Teen Patti Live",
        platform:"PT",
        type: "LIVE",
        gameCode: "PT-LIVE-087",
        imgSrc: "/assets/images/home/TeenPattiLiveByPlaytech.webp",
    },
    {
        class:"entrance-half",
        title:"Bet On Dragon Tiger Live",
        platform:"PT",
        type: "LIVE",
        gameCode: "PT-LIVE-030",
        imgSrc: "/assets/images/home/pt-beton-dragon-tiger.webp",
    },
    {
        class:"entrance-half",
        title:"Super Sic Bo",
        platform:"EVOLUTION",
        type: "LIVE",
        gameCode: "EVOLUTION-LIVE-005",
        imgSrc: "/assets/images/home/evo-super-sicbo.webp",
    },
    {
        class:"entrance-half",
        title:"Lightning Roulette",
        platform:"EVOLUTION",
        type: "LIVE",
        gameCode: "EVOLUTION-LIVE-040",
        imgSrc: "/assets/images/home/evo-lightning-roulette.webp",
    },
    {
        class:"entrance-half",
        title:"MONOPOLY Big Baller",
        platform:"EVOLUTION",
        type: "LIVE",
        gameCode: "EVOLUTION-LIVE-018",
        imgSrc: "/assets/images/home/evo-monopoly-big-baller.webp",
    },
    {
        class:"entrance-half",
        title:"Mega Ball",
        platform:"EVOLUTION",
        type: "LIVE",
        gameCode: "EVOLUTION-LIVE-010",
        imgSrc: "/assets/images/home/evo-megaball.webp",
    },
    {
        class:"entrance-half",
        title:"Auto-Roulette",
        platform:"EVOLUTION",
        type: "LIVE",
        gameCode: "EVOLUTION-LIVE-170",
        imgSrc: "/assets/images/home/evo-auto-roulette.webp",
    },
    {
        class:"entrance-half",
        title:"Crazy Coin Flip",
        platform:"EVOLUTION",
        type: "LIVE",
        gameCode: "EVOLUTION-LIVE-014",
        imgSrc: "/assets/images/home/evo-crazy-coin-flip.webp",
    },
    {
        class:"entrance-half",
        title:"Dragon Tiger",
        platform:"EVOLUTION",
        type: "LIVE",
        gameCode: "EVOLUTION-LIVE-004",
        imgSrc: "/assets/images/home/evo-dragon-tiger.webp",
    },
    {
        class:"entrance-half",
        title:"Dream Catcher",
        platform:"EVOLUTION",
        type: "LIVE",
        gameCode: "EVOLUTION-LIVE-035",
        imgSrc: "/assets/images/home/evo-dream-catcher.webp",
    },
    {
        class:"entrance-half",
        title:"Fan Tan",
        platform:"EVOLUTION",
        type: "LIVE",
        gameCode: "EVOLUTION-LIVE-178",
        imgSrc: "/assets/images/home/evo-fan-tan.webp",
    },
    {
        class:"entrance-half",
        title:"Dead or Alive: Saloon",
        platform:"EVOLUTION",
        type: "LIVE",
        gameCode: "EVOLUTION-LIVE-176",
        imgSrc: "/assets/images/home/evo-dead-alive.webp",
    },
    {
        class:"entrance-half",
        title:"Lightning Dragon Tiger",
        platform:"EVOLUTION",
        type: "LIVE",
        gameCode: "EVOLUTION-LIVE-344",
        imgSrc: "/assets/images/home/Evolution-Lightning-Dragon-Tiger.webp",
    },
    {
        class:"entrance-half",
        title:"Funky Time",
        platform:"EVOLUTION",
        type: "LIVE",
        gameCode: "EVOLUTION-LIVE-183",
        imgSrc: "/assets/images/home/evo-funky-time.webp",
    },
    {
        class:"entrance-half",
        title:"MONOPOLY Live",
        platform:"EVOLUTION",
        type: "LIVE",
        gameCode: "EVOLUTION-LIVE-007",
        imgSrc: "/assets/images/home/evo-monopoly-live.webp",
    },
    {
        class:"entrance-half",
        title:"XXXtreme Lightning Roulette",
        platform:"EVOLUTION",
        type: "LIVE",
        gameCode: "EVOLUTION-LIVE-205",
        imgSrc: "/assets/images/home/evo-xxtremelightning-roulette.webp",
    },
]

export {homeLinkCardObj}